var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0 text-center"},[_c('span',{staticClass:"d-md-block"},[_vm._v("© "+_vm._s(_vm.current_year)+" "+_vm._s(_vm.appName)+" | Powered by Signal Sure AI Agent")])])}
var staticRenderFns = []

export { render, staticRenderFns }